require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-neusiedl-edelstal.json") })
        }
      }, "path---betreuungseinrichtungen-neusiedl-edelstal");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-neusiedl-edelstal!./.cache/json/betreuungseinrichtungen-neusiedl-edelstal.json
// module id = 947
// module chunks = 231608221292675